import { ErrorSummary } from '@digdir/designsystemet-react';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { useOppvarmingFormContext } from '../../utils';
import { ErrorGroupWrapper } from '../formErrors/styledComponents';
import { hasErrors } from '../formErrors/utils';
import { ErrorLinkItem } from '../formErrors/errorLinkItem';

// Fjernvarme errors
export const FjernvarmeErrorSummary = () => {
  const { formState } = useOppvarmingFormContext();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming.fjernvarme' });

  const errors = formState.errors.fjernvarme?.value;

  // Radiator and gulvvarme selection is validated as a group and has common validation and error message.
  // We only display radiator error message.
  const fordelingssystemSelectionError = errors?.radiator?.selected;

  // All checkboxes share the same validation and message. We use the one from romoppvarming.
  const varmefordelingSelection = errors?.bruk?.romoppvarming;

  if (!errors) {
    return null;
  }

  return (
    <Fragment>
      {hasErrors(errors) && (
        <ErrorGroupWrapper>
          <ErrorSummary.Heading>{t('label')}</ErrorSummary.Heading>
          <ErrorSummary.List>
            <ErrorLinkItem error={errors?.varmesentral?.installasjonsAr} />
            <ErrorLinkItem error={errors?.varmesentral?.vetInstallasjonsAr} />
            <ErrorLinkItem error={errors?.varmesentral?.installertIOppvarmetRom} />
            <ErrorLinkItem error={varmefordelingSelection} />
            <ErrorLinkItem error={fordelingssystemSelectionError} />
            <ErrorLinkItem error={errors?.gulvvarme?.value?.termostatstyring} />
            <ErrorLinkItem error={errors?.radiator?.value?.termostatstyring} />
          </ErrorSummary.List>
        </ErrorGroupWrapper>
      )}
    </Fragment>
  );
};
